import { Component, OnInit, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { postMsg } from "@root/router/public/h5/channel/util";
import { isMobileDevice } from "@root/util/util";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "host-connect-with-google",
  templateUrl: "./connect-with-google.component.html",
  styleUrls: ["./connect-with-google.component.scss"],
})
export class V4ConnectWithGoogleComponent implements OnInit {
  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;

  constructor(
    @Optional() private modalRef: NzModalRef,
    private router: Router,
  ) {}

  ngOnInit() {}

  onCancel() {
    if (isMobileDevice()) {
      postMsg("BACK");
    } else {
      this.modalRef.destroy();
    }
  }

  toBookingsite() {
    this.modalRef.destroy();
    this.router.navigate(["/app/booking-site"]);
  }
}
